// Image
import avatar1 from '../../assets/images/users/avatar-1.jpg';
import avatar2 from '../../assets/images/users/avatar-2.jpg';
import avatar3 from '../../assets/images/users/avatar-3.jpg';
import avatar4 from '../../assets/images/users/avatar-4.jpg';
import avatar5 from '../../assets/images/users/avatar-5.jpg';
import avatar6 from '../../assets/images/users/avatar-6.jpg';
import avatar8 from '../../assets/images/users/avatar-8.jpg';
import avatar9 from '../../assets/images/users/avatar-9.jpg';
import avatar10 from '../../assets/images/users/avatar-10.jpg';

const teamtab = [
    {
        id: 1,
        bookmark: false,
        img: avatar9,
        name: "Ross Jordan",
        userName: "@ross",
        position: "Web Designer",
        contactNo: "501-804-0411",
        email: "rossjordan@gmail.com",
        designation: "Web Designer",
        progress: 32,
        projects: "874",
        overdue: "21",
        tasks: "1032"
    },
    {
        id: 2,
        bookmark: true,
        img: avatar8,
        name: "Patience harrington",
        userName: "@patience",
        position: "Account Executive",
        contactNo: "870-455-0378",
        email: "patienceharrington@gmail.com",
        designation: "Account Executive",
        progress: 87,
        projects: "514",
        overdue: "21",
        tasks: "225"
    },
    {
        id: 3,
        bookmark: false,
        img: avatar6,
        name: "Bryant Diaz",
        userName: "@bryant",
        position: "Engineering Manager",
        contactNo: "530-461-3338",
        email: "bryantdiaz@gmail.com",
        designation: "Engineering Manager",
        progress: 85,
        projects: "302",
        overdue: "12",
        tasks: "712"
    },
    {
        id: 4,
        bookmark: true,
        img: avatar5,
        name: "Damon Boxter",
        userName: "@damon",
        position: "UI/UX Designer",
        contactNo: "303-215-6114",
        email: "damonboxter@gmail.com",
        designation: "UI/UX Designer",
        progress: 70,
        projects: "526",
        overdue: "18",
        tasks: "632"
    },
    {
        id: 5,
        bookmark: false,
        img: avatar4,
        name: "Jordan Villareal",
        userName: "@jordan",
        position: "Software Engineer",
        contactNo: "276-646-2337",
        email: "jordanvillareal@gmail.com",
        designation: "Software Engineer",
        progress: 65,
        projects: "321",
        overdue: "20",
        tasks: "1002"
    },
    {
        id: 6,
        bookmark: false,
        img: avatar3,
        name: "Cristofer Leblanc",
        userName: "@cristofer",
        position: "Product Manager",
        contactNo: "330-850-7683",
        email: "cristoferleblanc@gmail.com",
        designation: "Product Manager",
        progress: 50,
        projects: "285",
        overdue: "10",
        tasks: "132"
    },
    {
        id: 7,
        bookmark: true,
        img: avatar2,
        name: "Allyson Booker",
        userName: "@allyson",
        position: "Lead Product Design",
        contactNo: "314-835-9287",
        email: "allysonbooker@gmail.com",
        designation: "Lead Product Design",
        progress: 38,
        projects: "174",
        overdue: "15",
        tasks: "500"
    },
    {
        id: 8,
        bookmark: false,
        img: avatar1,
        name: "Marie Ward",
        userName: "@marie",
        position: "Project Manager",
        contactNo: "215-820-4037",
        email: "marieward@gmail.com",
        designation: "Project Manager",
        progress: 85,
        projects: "874",
        overdue: "21",
        tasks: "1032"
    }

];

const basicTeamData = [
    { id: 1, img: avatar9, name: "Jordan Martino", email: "jordan.martino@lizant.com" },
    { id: 2, img: avatar10, name: "Nancy Martino", email: "nancy.martino@lizant.com" },
    { id: 3, img: avatar1, name: "Pieter Novitsky", email: "pieter.novitsky@lizant.com" },
    { id: 4, img: avatar4, name: "Allyson Booker", email: "allyson.booker@lizant.com" },
    { id: 5, img: avatar3, name: "Cristofer Leblanc", email: "cristofer.leblanc@lizant.com" },
]

export { teamtab, basicTeamData };